import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

// export const BASE_URL = "http://localhost:9000";  

//3.11...............................................
// export const BASE_URL = "http://192.168.3.11:9201/api";
// export var REPORT_BASE_URL = `http://192.168.3.11:9201/doc`;

//UAT...............................................
// export const BASE_URL = "https://bookings_uat.itmecenter.in/api";
// export var REPORT_BASE_URL = `https://bookings_uat.itmecenter.in/doc`;

//PROD...............................................
export const BASE_URL = "https://bookings.itmecenter.in/api";
export var REPORT_BASE_URL = `https://bookings.itmecenter.in/doc`;

// export var BASE_URL = `http://${window.location.host}:9000`;
// prod url with HTTPS.....................................................
// export var BASE_URL = `https://${window.location.host}/api`;
// prod url with HTTP only.....................................................
// export var BASE_URL = `http://${window.location.host}/api`;

// export var REPORT_BASE_URL = `https://ems_uat.india-itme.com/doc`;
export const fetchReport = `${REPORT_BASE_URL}/report/SetParameterData`;
export const downloadReport = `${REPORT_BASE_URL}/WebForm/ItmeReportViewer.aspx`;
export const Receipt = "ReceiptVoucher-New.rpt";

//PAYMENT KEYS UAT
// export const key_id = "rzp_test_huhVnucX8JP75Y";
// export const key_secret = "qiav7fbmtMYxH4YKNsosNSbs";
//PAYMENT KEYS LIVE
export const key_id = "rzp_live_wqXB7At9DNaQgG";
export const key_secret = "KMVvozkRXZwKrIIW0Dx6hujR";
export const merchantName = "ITME CENTER";
export const merchantDescription = "";
export const prefilName = "";
export const prefilContact = "";
export const prefilEmail = "";
export const prefilAddress = "";
// export const razorpayCheckoutUrl = 'https://checkout.razorpay.com/v1/checkout.js';
export const razorpayCheckoutUrl = 'http://api.razorpay.com/v1/checkout/embedded';


export const performaInvoice = "proformacombine.rpt";
export const performaInvoiceExit = "proformaExit.rpt";
export const taxInvoice = "taxinvoice.rpt";
export const bonafideDocName = "bonafideCertificate.rpt";
export const noDueCertificate = "NoDue.rpt";
export const exitPassCertificate = "ExitPass.rpt";
export const creditNoteRPT = "CreditNote.rpt";
export const DebitNoteRPT = "DebitNote.rpt";
export const bookingFormRPT = "Booking Form.rpt";

export const paymentAccessCode = "AVVI64IL27CE56IVEC";
export const paymentPortalLink = "http://test.ccavenue.com//transaction/transaction.do?command=initiateTransaction"; //Dev
// export const paymentPortalLink="http://secure.ccavenue.com/transaction/transaction.do?command=initiateTransaction"; //UAT

export const sessionExpireMessage = 'Session expired! Please login again.'
export const tokenInavlidMessage = 'Token invalid'
// auth
export const loginUrl = `${BASE_URL}/auth/loginUser`;
export const changePasswordUrl = `${BASE_URL}/auth/changePassword`;
export const forgetPasswordUrl = `${BASE_URL}/auth/forgetPassword`;
export const updatePasswordUrl = `${BASE_URL}/auth/updatePassword`;
export const getOtpUrl = `${BASE_URL}/auth/getOtp`;
export const signUpUrl = `${BASE_URL}/auth/signUp`;

//Holidays
export const holidayListUrl = `${BASE_URL}/holiday/HolidaysList`;
export const holidayAddUrl = `${BASE_URL}/holiday/addHolidays`;
export const holidayDetailUrl = `${BASE_URL}/holiday/getHolidayDetails`;
export const holidayDeleteUrl = `${BASE_URL}/holiday/deleteHoliday`;

//Events
export const eventsListUrl = `${BASE_URL}/events/eventsList`;
export const eventsAddUrl = `${BASE_URL}/events/addEvents`;
export const eventsDetailUrl = `${BASE_URL}/events/getEventDetails`;
export const eventsDeleteUrl = `${BASE_URL}/events/deleteEvent`;

//Client
export const clientListUrl = `${BASE_URL}/client/clientsList`;
export const clientAddUrl = `${BASE_URL}/client/addClients`;
export const clientDetailUrl = `${BASE_URL}/client/getClientDetails`;
export const clientDeleteUrl = `${BASE_URL}/client/deleteClient`;

//vendor
export const vendorListUrl = `${BASE_URL}/vendor/vendorList`;
export const vendorAddUrl = `${BASE_URL}/vendor/addUpdateVendor`;
export const vendorDetailUrl = `${BASE_URL}/vendor/getVendorDetails`;
export const vendorDeleteUrl = `${BASE_URL}/vendor/deleteVendor`;

//timeSlot
export const timeSlotListUrl = `${BASE_URL}/timeSlot/timeSlotList`;
export const timeSlotAddUrl = `${BASE_URL}/timeSlot/addTimeSlot`;
export const timeSlotDetailUrl = `${BASE_URL}/timeSlot/getTimeSlotDetails`;
export const timeSlotDeleteUrl = `${BASE_URL}/timeSlot/deleteTimeSlot`;

//seatingType
export const seatingTypeListUrl = `${BASE_URL}/seatingType/seatingTypeList`;
export const seatingTypeAddUrl = `${BASE_URL}/seatingType/addSeatingType`;
export const seatingTypeDetailUrl = `${BASE_URL}/seatingType/getSeatingTypeDetails`;
export const seatingTypeDeleteUrl = `${BASE_URL}/seatingType/deleteSeatingType`;

//Additional Services
export const serviceListUrl = `${BASE_URL}/masterAdditionalService/serviceList`;
export const serviceAddUrl = `${BASE_URL}/masterAdditionalService/addService`;
export const serviceDetailUrl = `${BASE_URL}/masterAdditionalService/getServiceDetails`;
export const serviceDeleteUrl = `${BASE_URL}/masterAdditionalService/deleteService`;

//Multi Purpose Centre
export const MultiPurposeCentreListUrl = `${BASE_URL}/MultiPurposeCentre/MultiPurposeCentreList`;
export const MultiPurposeCentreAddUrl = `${BASE_URL}/MultiPurposeCentre/addMultiPurposeCentre`;
export const MultiPurposeCentreDetailUrl = `${BASE_URL}/MultiPurposeCentre/getMultiPurposeCentreDetails`;
export const MultiPurposeCentreDeleteUrl = `${BASE_URL}/MultiPurposeCentre/deleteMultiPurposeCentre`;
export const CenterPricingDeleteUrl = `${BASE_URL}/MultiPurposeCentre/deleteCentrePricing`;
export const CenterAdditionalServiceDeleteUrl = `${BASE_URL}/MultiPurposeCentre/deleteCentreAdditionalService`;

//orders
export const myOrdersListUrl = `${BASE_URL}/orders/myOrdersList`;
export const editOrderUrl = `${BASE_URL}/orders/editOrder`;
export const insertProformaInvoiceUrl = `${BASE_URL}/orders/insertProformaInvoice`;
export const blockedTillUrl = `${BASE_URL}/orders/blockedTill`;
export const followUpurl = `${BASE_URL}/orders/followUpNote`;
export const getFollowUpUrl = `${BASE_URL}/orders/getFollowNote`
export const deleteMyOrderUrl = `${BASE_URL}/orders/cancelOrder`;
export const cancelOrderReasonUrl = `${BASE_URL}/orders/cancelOrderReason`
export const generateNoDueUrl = `${BASE_URL}/orders/generateNoDue`;
export const updateExitPassUrl = `${BASE_URL}/orders/updateExitPass`
export const eventClosureUrl = `${BASE_URL}/orders/eventClosure`;
export const orderApproveUrl = `${BASE_URL}/orders/orderApproval`
export const orderAdditionalServicesIEUrl = `${BASE_URL}/orders/orderAdditionalServices`
export const orderAdditionalServicesApprovalUrl = `${BASE_URL}/orders/updateAdditionalServiceApproval`
export const orderUpdateAdditionalHourUrl = `${BASE_URL}/orders/updateAdditionalHours`
export const orderUpdateAdditionalDiscountUrl = `${BASE_URL}/orders/updateAdditionalDiscount`
export const orderUpdateRentalDiscountUrl = `${BASE_URL}/orders/updateRentalDiscount`
export const orderUpdateSecurityDepositUrl = `${BASE_URL}/orders/updateSecurityDeposit`
export const orderUpdateEventServiceUrl = `${BASE_URL}/orders/updateEventService`
export const sendApprovalPiMailUrl=`${BASE_URL}/orders/sendPI`;
//chat
export const chatDetailsUrl = `${BASE_URL}/chat/getChatDetails`;
export const sendChatUrl = `${BASE_URL}/chat/insertChat`;

//security
//roles
export const roleListUrl = `${BASE_URL}/roles/rolesList`;
export const insertUpdateRoleUrl = `${BASE_URL}/roles/insertUpdateRole`;
export const roleDetailUrl = `${BASE_URL}/roles/getRoleDetails`;
export const roleDeleteUrl = `${BASE_URL}/roles/deleteRole`;

//account Debit note
export const debitNoteListUrl = `${BASE_URL}/debitNote/debitNoteList`
export const debitNoteDetailsUrl = `${BASE_URL}/debitNote/getDebitNoteDetails`
export const debitNoteDetailsOrderUrl = `${BASE_URL}/debitNote/debitNoteDetailsOrder`
export const insertEditDebitNoteUrl = `${BASE_URL}/debitNote/insertEditDebitNote`
export const deleteDebitNoteUrl = `${BASE_URL}/debitNote/deleteDebitNote`

//account credit note
export const creditNoteListUrl = `${BASE_URL}/creditNote/creditNoteList`
export const creditNoteDetailsUrl = `${BASE_URL}/creditNote/creditNoteDetails`
export const creditNoteDetailsOrderUrl = `${BASE_URL}/creditNote/creditNoteDetailsOrder`
export const insertEditCreditNoteUrl = `${BASE_URL}/creditNote/insertEditCreditNote`
export const deleteCreditNoteUrl = `${BASE_URL}/creditNote/deleteCreditNote`

//account Due Payments
export const duePaymentListUrl = `${BASE_URL}/duePayment/duePaymentList`;

//account Invoices
export const invoicesListUrl = `${BASE_URL}/invoices/invoicesList`;

//payment url ....
export const paymentUrl = `${BASE_URL}/payment/sendPayment`;
export const generateUniqueNoUrl = `${BASE_URL}/payment/generateUniqueNo`;
export const paymentRedirectUrl = `${BASE_URL}/payment/paymentResponse`;
//razorpay
export const createOrderUrl = `${BASE_URL}/payment/createOrder`;
export const paymentVerificationUrl = `${BASE_URL}/payment/paymentVerification`;
export const paymentStatusUrl = `${BASE_URL}/payment/paymentStatus`;


// dashboard
export const adminDashboardUrl = `${BASE_URL}/dashboard/getDashboardData`;

//calender view
export const searchCalenderListUrl = `${BASE_URL}/calender/calenderList`;
export const blockCalenderUrl = `${BASE_URL}/calender/blockCalender`;
export const getBlockedCalenderListUrl = `${BASE_URL}/calender/getBlockedCalenderList`;
export const unblockCalenderUrl = `${BASE_URL}/calender/unblockCalender`;

//fill LIST
export const getFillListUrl = `${BASE_URL}/fillList/getFillList`;

// Booking Details
export const bookingDetailsUrl = `${BASE_URL}/bookingDetails/bookingDetails`;
export const getBookingDetailsUrl = `${BASE_URL}/bookingDetails/getBookingDetails`;
export const deleteTableBookingDetailsUrl = `${BASE_URL}/bookingDetails/tableDeleteBookingDetails`;
export const updateMembershipFileUrl = `${BASE_URL}/bookingDetails/updateMembershipFile`;
export const getPriceAndTimeUrl = `${BASE_URL}/bookingDetails/getPriceAndTime`;
export const checkMeetingSlotsUrl = `${BASE_URL}/bookingDetails/checkMeetingSlots`;

// company Info
export const addUpdateCompanyInfoUrl = `${BASE_URL}/companyInfo/addUpdatecompanyInfo`;
export const getAddUpdatecompanyInfoDetails = `${BASE_URL}/companyInfo/getAddUpdatecompanyInfoDetails`;

// additional Services
export const getAdditonalServicesUrl = `${BASE_URL}/additionalServices/additionalServicesDetails`;
export const addUpdateAdditonalServicesUrl = `${BASE_URL}/additionalServices/addUpdateAdditionalServices`;
export const getServiceVendorPackageDetailsUrl = `${BASE_URL}/additionalServices/getServiceVendorPackageDetails`;

// terms and conditons
export const termsAndConditonsAUURL = `${BASE_URL}/termsAndConditions/termsAndConditionsAU`;
export const getTermsAndConditionsDetailsURl = `${BASE_URL}/termsAndConditions/getTermsAndConditionsDetails`;

// summary Details
export const getSummaryDetailsUrl = `${BASE_URL}/summary/getSummaryDetails`;
export const submitSummaryFormUrl = `${BASE_URL}/summary/submitSummaryForm`;


// order confirmation
export const getOrderConfirmationUrl = `${BASE_URL}/orderConfirmation/getBookingConfirmation`;
export const getpaymentDetailsForDownloadUrl = `${BASE_URL}/orderConfirmation/getpaymentDetailsForDownload`;
export const getpaymentDetailsForEmailUrl = `${BASE_URL}/orderConfirmation/getpaymentDetailsForEmail`;

// user
export const getUserListUrl = `${BASE_URL}/user/getUserList`;
export const getUserDetailsUrl = `${BASE_URL}/user/getUserDetails`;
export const addUpdateUserUrl = `${BASE_URL}/user/addUpdateUser`;
export const deleteUserUrl = `${BASE_URL}/user/deleteUserList`;

// cart Details
export const getCartDetailsUrl = `${BASE_URL}/cart/getCartDetails`;
export const saveForLaterUrl = `${BASE_URL}/cart/saveForLater`;
export const removeOrderUrl = `${BASE_URL}/cart/removeOrder`;
export const addToCartUrl = `${BASE_URL}/cart/addToCart`;

// reports
export const getOrderReportListUrl = `${BASE_URL}/reports/getOrderReportList`;
export const getFeedbackReportListUrl = `${BASE_URL}/reports/getFeedbackReportList`;
export const getPendingSecurityDepositReportListUrl = `${BASE_URL}/reports/getPendingSecurityDepositReportList`;
export const getReceiptReportListUrl = `${BASE_URL}/reports/getReceiptReportList`;
export const getInvoiceReportListUrl = `${BASE_URL}/reports/getInvoiceReportList`;
export const getReportListUrl = `${BASE_URL}/reports/getReportList`;


//Booking details Aside
export const getbookingDetailsAsideUrl = `${BASE_URL}/bookingDetailsAside/getAsideDetails`;

// Account-----------
// accountReciept
export const getAccountReceiptListUrl = `${BASE_URL}/accountReceipt/getAccountReceiptList`;
export const deleteAccountReceiptListUrl = `${BASE_URL}/accountReceipt/deleteAccountReceiptList`;
export const getAccountReceiptDetailsUrl = `${BASE_URL}/accountReceipt/getAccountReceiptDetails`;
export const getPerformaInvoiceReceiptListUrl = `${BASE_URL}/accountReceipt/getPerformaInvoiceReceiptList`;
export const addAccountReceiptListUrl = `${BASE_URL}/accountReceipt/addAccountReceipt`;
export const updateAccountReceiptListUrl = `${BASE_URL}/accountReceipt/updateAccountReceipt`;
export const accountReceiptGenerateInvoiceUrl = `${BASE_URL}/accountReceipt/generateVoucher`;
export const getReceiptNoUrl = `${BASE_URL}/accountReceipt/getReceiptNo`;
export const ReceiptUpdateNoDueUrl = `${BASE_URL}/accountReceipt/updateNoDue`;
export const ReceiptUpdateTaxInvoiceUrl = `${BASE_URL}/accountReceipt/updateTaxInvoice`;
export const getSendMailReceiptDetailsUrl = `${BASE_URL}/accountReceipt/getSendMailReceiptDetails`;
export const sendTaxInvoiceUrl = `${BASE_URL}/accountReceipt/sendTaxInvoice`;
export const previewRecieptUrl = `${BASE_URL}/accountReceipt/previewReciept`;


//account third party order list
export const getThirdPartyOrdersListUrl = `${BASE_URL}/accountThirdParty/getThirdPartyOrdersList`;
export const getThirdPartyOrdersDetailsUrl = `${BASE_URL}/accountThirdParty/getThirdPartyDetails`;
export const getThirdPartyVendorOrdersDetailsUrl = `${BASE_URL}/accountThirdParty/getVendorOrderDetails`;
export const insertUpdateThirdPartyVendorOrderDtlUrl = `${BASE_URL}/accountThirdParty/insertUpdateVendorOrderDtl`;

// guideline
export const insertUpdateGuidelineUrl = `${BASE_URL}/guideline/insertUpdateGuideline`;
export const getGuidelineFileUrl = `${BASE_URL}/guideline/getGuidelineFile`;

// checkList
export const getCheckListPossessionListUrl = `${BASE_URL}/checkList/getPossessionList`;
export const insertCheckListPossessionListUrl = `${BASE_URL}/checkList/insertPossessionList `;
export const getCheckListExistListUrl = `${BASE_URL}/checkList/getExitList`;
export const insertExitListUrl = `${BASE_URL}/checkList/insertExitList`;
export const sendNewPIUrl = `${BASE_URL}/checkList/sendNewPI`;

// feedback
export const getFeedbackVenueDetailsUrl = `${BASE_URL}/feedback/getFeedbackVenueDetails`;
export const insertFeedbackUrl = `${BASE_URL}/feedback/insertFeedback`;
export const getFeedbackDetailsUrl = `${BASE_URL}/feedback/getFeedbackDetails`;

export const headers = {
  Accept: "application/json, text/plain, */*", // It can be used to overcome cors errors
  "Content-Type": "application/json",
};

// login
export const LOGIN_ACTION_TYPE = "LOGIN";
export const PAYMENT_ACTION_TYPE = "PAYMENT";
export const GENERATE_UNIQUE_NO = "GENERATE_UNIQUE_NO";
export const CREATE_PAYMENT_ORDER = "CREATE_PAYMENT_ORDER";

export const CHANGE_PASSWORD_ACTION_TYPE = "CHANGE_PASSWORD_ACTION_TYPE";
export const FORGET_PASSWORD_ACTION_TYPE = "FORGET_PASSWORD_ACTION_TYPE";
export const UPDATE_PASSWORD_ACTION_TYPE = "UPDATE_PASSWORD_ACTION_TYPE";
export const GET_OTP_ACTION_TYPE = "GET_OTP_ACTION_TYPE";
export const SIGNUP_ACTION_TYPE = "SIGNUP_ACTION_TYPE";
export const FILL_LIST_ACTION_TYPE = "FILL_LIST_ACTION_TYPE";

//holiday action
export const HOLIDAY_LIST_ACTION_TYPE = "HOLIDAY_LIST";
export const HOLIDAY_ADD_ACTION_TYPE = "HOLIDAY_ADD";
export const HOLIDAY_DETAIL_ACTION_TYPE = "HOLIDAY_DETAIL";
export const HOLIDAY_DELETE_ACTION_TYPE = "HOLIDAY_DELETE";

//Event action
export const EVENT_LIST_ACTION_TYPE = "EVENT_LIST";
export const EVENT_ADD_ACTION_TYPE = "EVENT_ADD";
export const EVENT_DETAIL_ACTION_TYPE = "EVENT_DETAIL";
export const EVENT_DELETE_ACTION_TYPE = "EVENT_DELETE";

//Client Action
export const CLIENT_LIST_ACTION_TYPE = "CLIENT_LIST";
export const CLIENT_ADD_ACTION_TYPE = "CLIENT_ADD";
export const CLIENT_DETAIL_ACTION_TYPE = "CLIENT_DETAIL";
export const CLIENT_DELETE_ACTION_TYPE = "CLIENT_DELETE";

//VENDOR Action
export const VENDOR_LIST_ACTION_TYPE = "VENDOR_LIST";
export const VENDOR_ADD_ACTION_TYPE = "VENDOR_ADD";
export const VENDOR_DETAIL_ACTION_TYPE = "VENDOR_DETAIL";
export const VENDOR_DELETE_ACTION_TYPE = "VENDOR_DELETE";

//TIMESLOT Action
export const TIMESLOT_LIST_ACTION_TYPE = "TIMESLOT_LIST";
export const TIMESLOT_ADD_ACTION_TYPE = "TIMESLOT_ADD";
export const TIMESLOT_DETAIL_ACTION_TYPE = "TIMESLOT_DETAIL";
export const TIMESLOT_DELETE_ACTION_TYPE = "TIMESLOT_DELETE";

//SEATINGTYPE Action
export const SEATINGTYPE_LIST_ACTION_TYPE = "SEATINGTYPE_LIST";
export const SEATINGTYPE_ADD_ACTION_TYPE = "SEATINGTYPE_ADD";
export const SEATINGTYPE_DETAIL_ACTION_TYPE = "SEATINGTYPE_DETAIL";
export const SEATINGTYPE_DELETE_ACTION_TYPE = "SEATINGTYPE_DELETE";

//Additional Service Action
export const SERVICE_LIST_ACTION_TYPE = "SERVICE_LIST";
export const SERVICE_ADD_ACTION_TYPE = "SERVICE_ADD";
export const SERVICE_DETAIL_ACTION_TYPE = "SERVICE_DETAIL";
export const SERVICE_DELETE_ACTION_TYPE = "SERVICE_DELETE";

//Multi Purpose Centre Action
export const MULTI_PURPOSE_CENTRE_LIST_ACTION_TYPE =
  "MULTI_PURPOSE_CENTRE_LIST";
export const MULTI_PURPOSE_CENTRE_ADD_ACTION_TYPE = "MULTI_PURPOSE_CENTRE_ADD";
export const MULTI_PURPOSE_CENTRE_DETAIL_ACTION_TYPE =
  "MULTI_PURPOSE_CENTRE_DETAIL";
export const MULTI_PURPOSE_CENTRE_DELETE_ACTION_TYPE =
  "MULTI_PURPOSE_CENTRE_DELETE";
export const MULTI_PURPOSE_CENTRE_PRICING_DELETE_ACTION_TYPE = "CENTRE_PRICING_DELETE";
export const MULTI_PURPOSE_CENTRE_ADDITIONAL_DELETE_ACTION_TYPE = "CENTRE_ADDITIONAL_DELETE";

//orders Action
export const MY_ORDERS_LIST_ACTION_TYPE = "MY_ORDERS_LIST";
export const EDIT_ORDER_ACTION_TYPE = "EDIT_ORDER";
export const INSERT_PROFORMA_INVOICE_ACTION_TYPE = "INSERT_PROFORMA_INVOICE";
export const BLOCKED_TILL_ACTION_TYPE = "BLOCKED_TILL";
export const FOLLOW_UP_ACTION_TYPE = "FOLLOW_UP_NOTE";
export const GET_FOLLOWUP_ACTION_TYPE = "GET_FOLLOW_UP_NOTE";
export const DELETE_MY_ORDER_ACTION_TYPE = "DELETE_MY_ORDER";
export const ORDER_CANCEL_REASON_ACTION_TYPE = "ORDER_CANCEL_REASON"
export const DOWNLOAD_NODUE_ACTION_TYPE = "DOWNLOAD_NODUE_RPT";
export const GENERATE_NODUE_ACTION_TYPE = "GENERATE_NODUE";
export const UPDATE_EXIT_PASS_ACTION_TYPE = "UPDATE_EXIT_PASS";
export const EVENT_CLOSURE_ACTION_TYPE = "EVENT_CLOSURE";
export const ORDER_APPROVAL_ACTION_TYPE = "ORDER_APPROVAL";
export const ORDER_ADDITIONAL_SERVICE_IE_TYPE = "ORDER_ADDITIONAL_SERVICE_IE"
export const ORDER_ADDITIONAL_SERVICE_APPROVAL_ACTION_TYPE = "ORDER_ADDITIONAL_SERVICE_APPROVAL"
export const ORDER_UPDATE_ADDITIONAL_HOUR = "ORDER_UPDATE_ADDITIONAL_HOUR";
export const ORDER_UPDATE_ADDITIONAL_DISCOUNT = "ORDER_UPDATE_ADDITIONAL_DISCOUNT";
export const ORDER_UPDATE_RENTAL_DISCOUNT = "ORDER_UPDATE_RENTAL_DISCOUNT";
export const ORDER_UPDATE_SECURITY_DEPOSIT = "ORDER_UPDATE_SECURITY_DEPOSIT";
export const ORDER_UPDATE_EVENT_SERVICE = "ORDER_UPDATE_EVENT_SERVICE";
export const SEND_APPROVAL_PI_MAIL = "SEND_APPROVAL_PI_MAIL";

//chat
export const CHAT_DETAILS_ACTION_TYPE = "CHAT_DETAILS";
export const CHAT_INSERT_ACTION_TYPE = "CHAT_INSERT";

//roles
export const ROLES_LIST_ACTION_TYPE = "ROLES_LIST";
export const INSERT_UPDATE_ROLES_ACTION_TYPE = "INSERT_UPDATE_ROLES";
export const DELETE_ROLE_ACTION_TYPE = "DELETE_ROLE";
export const ROLE_DETAILS_ACTION_TYPE = "ROLE_DETAILS";

//account debit note
export const DEBIT_NOTE_LIST_ACTION_TYPE = "DEBIT_NOTE_LIST";
export const DEBIT_NOTE_DETAILS_ORDER_ACTION_TYPE = "DEBIT_NOTE_DETAILS_ORDER";
export const DEBIT_NOTE_DETAILS_ACTION_TYPE = "DEBIT_NOTE_DETAILS";
export const DEBIT_NOTE_IE_ACTION_TYPE = "DEBIT_NOTE_IE";
export const DEBIT_NOTE_DELETE_ACTION_TYPE = "DEBIT_NOTE_DELETE";
export const DEBIT_NOTE_DOWNLOAD_ACTION_TYPE = "DEBIT_NOTE_DOWNLOAD"

//account credit note
export const CREDIT_NOTE_DELETE_ACTION_TYPE = "CREDIT_NOTE_LIST";
export const CREDIT_NOTE_DETAILS_ORDER_ACTION_TYPE = "CREDIT_NOTE_DETAILS_ORDER";
export const CREDIT_NOTE_DETAILS_ACTION_TYPE = "CREDIT_NOTE_DETAILS";
export const CREDIT_NOTE_IE_ACTION_TYPE = "CREDIT_NOTE_IE";
export const CREDIT_NOTE_LIST_ACTION_TYPE = "CREDIT_NOTE_DELETE";
export const CREDIT_NOTE_DOWNLOAD_ACTION_TYPE = "CREDIT_NOTE_DOWNLOAD"

//account Due Payment
export const DUE_PAYMENT_LIST_ACTION_TYPE = "DUE_PAYMENT_LIST";

//account Invoices
export const INVOICES_LIST_ACTION_TYPE = "INVOICES_LIST";

//calender
export const SEARCH_CALENDER_LIST = "SEARCH_CALENDER_LIST";
export const BLOCK_CALENDER = "BLOCK_CALENDER";
export const GET_BLOCKED_CALENDER_LIST = "GET_BLOCKED_CALENDER_LIST";
export const UNBLOCK_CALENDER = "UNBLOCK_CALENDER";

//fill LIST
export const GET_FILL_LIST_ACTION_TYPE = "GET_FILL_LIST_ACTION_TYPE";

// Booking Details
export const BOOKING_DETAILS_ACTION_TYPE = "BOOKING_DETAILS_ACTION_TYPE";
export const GET_BOOKING_DETAILS_ACTION_TYPE =
"GET_BOOKING_DETAILS_ACTION_TYPE";
export const DELETE_TABLE_BOOKING_DETAILS_ACTION_TYPE =
"DELETE_TABLE_BOOKING_DETAILS_ACTION_TYPE";
export const UPDATE_MEMBERSHIP_FILE_ACTION_TYPE =
  "UPDATE_MEMBERSHIP_FILE_ACTION_TYPE";
export const GET_PRICE_AND_TIME_ACTION_TYPE =
  "GET_PRICE_AND_TIME_ACTION_TYPE";
export const CHECK_MEETING_SLOTS_ACTION_TYPE = "CHECK_MEETING_SLOTS_ACTION_TYPE";

// company Info
export const ADD_UPDATE_COMPANY_INFO_ACTION_TYPE =
  "ADD_UPDATE_COMPANY_INFO_ACTION_TYPE";
export const GET_ADD_UPDATE_COMPANY_INFO_DETAILS_ACTION_TYPE =
  "GET_ADD_UPDATE_COMPANY_INFO_DETAILS_ACTION_TYPE";

// additional Services
export const GET_ADDITIONAL_SERVICES_ACTION_TYPE =
  "GET_ADDITIONAL_SERVICES_ACTION_TYPE";
export const ADD_UPDATE_ADDITIONAL_SERVICES_ACTION_TYPE =
  "ADD_UPDATE_ADDITIONAL_SERVICES_ACTION_TYPE";
export const GET_SERVICE_VENDOR_PACKAGE_DETAILS_ACTION_TYPE =
  "GET_SERVICE_VENDOR_PACKAGE_DETAILS_ACTION_TYPE";

//Terms and conditions
export const TERMS_AND_CONDITIONS_AU = "TERMS_AND_CONDITIONS_AU";
export const GET_TERMS_AND_CONDITIONS_DETAILS =
  "GET_TERMS_AND_CONDITIONS_DETAILS";

//Summary
export const GET_SUMMARY_DETAILS = "GET_SUMMARY_DETAILS";
export const SUBMIT_SUMMARY_FORM = "SUBMIT_SUMMARY_FORM";


//order confimation
export const GET_ORDER_CONFIRMATION = "GET_ORDER_CONFIRMATION";
export const GET_PAYMENT_DETAILS_FOR_DOWNLOAD = "GET_PAYMENT_DETAILS_FOR_DOWNLOAD";
export const GET_PAYMENT_DETAILS_FOR_EMAIL = "GET_PAYMENT_DETAILS_FOR_EMAIL";
export const DOWNLOAD_PERFORMA_INVOICE = "DOWNLOAD_PERFORMA_INVOICE";
export const DOWNLOAD_BOOKING_FORM = "DOWNLOAD_BOOKING_FORM";
export const DOWNLOAD_TAX_INVOICE = "DOWNLOAD_TAX_INVOICE";

//Reports
export const GET_ORDER_REPORT = "GET_ORDER_REPORT";
export const GET_FEEDBACK_REPORT = "GET_FEEDBACK_REPORT";
export const GET_PENDING_SECURITY_DEPOSITE_REPORT = "GET_PENDING_SECURITY_DEPOSITE_REPORT";
export const GET_RECEIPT_REPORT = "GET_RECEIPT_REPORT";
export const GET_INVOICE_REPORT = "GET_INVOICE_REPORT";
export const GET_REPORT_LIST = "GET_REPORT_LIST";

// User
export const GET_USER_LIST_ACTION_TYPE = "GET_USER_LIST_ACTION_TYPE";
export const GET_USER_DETAILS_ACTION_TYPE = "GET_USER_DETAILS_ACTION_TYPE";
export const ADD_UPDATE_USER_ACTION_TYPE = "ADD_UPDATE_USER_ACTION_TYPE";
export const DELETE_USER_ACTION_TYPE = "DELETE_USER_ACTION_TYPE";

//Cart
export const GET_CART_DETAILS = "GET_CART_DETAILS";
export const SAVE_FOR_LATER = "SAVE_FOR_LATER";
export const REMOVE_ORDER = "REMOVE_ORDER";
export const ADD_TO_CART = "ADD_TO_CART";

//Booking details aside
export const GET_BOOKING_DETAILS_ASIDE = "GET_BOOKING_DETAILS_ASIDE";

// Account ----------

// AccountReciept
export const GET_ACCOUNT_RECEIPT_LIST = "GET_ACCOUNT_RECEIPT_LIST";
export const DELETE_ACCOUNT_RECEIPT_LIST = "DELETE_ACCOUNT_RECEIPT_LIST";
export const GET_ACCOUNT_RECEIPT_DETAILS = "GET_ACCOUNT_RECEIPT_DETAILS";
export const GET_PERFORMA_INVOICE_RECEIPT_LIST = "GET_PERFORMA_INVOICE_RECEIPT_LIST";
export const ADD_ACCOUNT_RECEIPT_LIST = "ADD_ACCOUNT_RECEIPT_LIST";
export const UPDATE_ACCOUNT_RECEIPT_LIST = "UPDATE_ACCOUNT_RECEIPT_LIST";
export const ACCOUNT_RECEIPT_GENERATE_INVOICE = "ACCOUNT_RECEIPT_GENERATE_INVOICE";
export const GET_RECEIPT_NO_ACTION_TYPE = "GET_RECEIPT_NO_ACTION_TYPE";
export const RECEIPT_NO_DUE_ACTION_TYPE = "RECEIPT_NO_DUE_ACTION_TYPE";
export const RECEIPT_TAX_INVOICE_ACTION_TYPE = "RECEIPT_TAX_INVOICE_ACTION_TYPE";
export const GET_SEND_MAIL_RECEIPT_DETAILS_ACTION_TYPE = "GET_SEND_MAIL_RECEIPT_DETAILS_ACTION_TYPE";
export const SEND_TAX_INVOICE_ACTION_TYPE = "SEND_TAX_INVOICE_ACTION_TYPE";
export const PREVIEW_RECEIPT_ACTION_TYPE = "PREVIEW_RECEIPT_ACTION_TYPE";

//third party orders
export const GET_ACCOUNT_THIRD_PARTY_ORDER_LIST = "GET_ACCOUNT_THIRD_PARTY_ORDER_LIST";
export const GET_ACCOUNT_THIRD_PARTY_ORDER_DETAILS = "GET_ACCOUNT_THIRD_PARTY_ORDER_DETAILS";
export const GET_ACCOUNT_THIRD_PARTY_VENDOR_ORDER_DETAILS = "GET_ACCOUNT_THIRD_PARTY_VENDOR_ORDER_DETAILS";
export const IU_ACCOUNT_THIRD_PARTY_VENDOR_ORDER_DETAILS = "IU_ACCOUNT_THIRD_PARTY_VENDOR_ORDER_DETAILS";

// Guideline
export const INSERT_UPDATE_GUIDELINE_ACTION = 'INSERT_UPDATE_GUIDELINE_ACTION'
export const GET_GUIDELINE_FILE_ACTION = 'GET_GUIDELINE_FILE_ACTION'

// checkList
export const GET_CHECKLIST_POSSESION_LIST = "GET_CHECKLIST_POSSESION_LIST";
export const INSERT_CHECKLIST_POSSESION_LIST = "INSERT_CHECKLIST_POSSESION_LIST";
export const GET_CHECKLIST_EXIST_LIST = "GET_CHECKLIST_EXIST_LIST";
export const INSERT_CHECKLIST_EXIST_LIST = "INSERT_CHECKLIST_EXIST_LIST";
export const SEND_NEW_PI_EXIST_LIST = "SEND_NEW_PI_EXIST_LIST";

// feedback
export const GET_FEEDBACK_VENUE_DETAILS_ACTION_TYPE = "GET_FEEDBACK_VENUE_DETAILS_ACTION_TYPE";
export const INSERT_FEEDBACK_ACTION_TYPE = "INSERT_FEEDBACK_ACTION_TYPE";
export const GET_FEEDBACK_DETAILS_ACTION_TYPE = "GET_FEEDBACK_DETAILS_ACTION_TYPE";

//action type end..........................

// action ID name
export const cityActionId = "1";
export const centerActionId = "2";
export const timeSlotActionId = "3";
export const stateActionId = "4";
export const countryActionId = "5";
export const additionalServiceActionId = "6";
export const roleActionId = "7";
export const ClientActionId = "8";
export const TypeOfEventActionId = "9";
export const EntryTypeActionId = "10";
export const SittingArrangementActionId = "11";
export const DeskActionId = "12";
export const DaysActionId = "15";
export const StatusActionId = "16";
export const currencyActionId = "17";
export const companyStatusActionId = "18";
export const moduleActionId = "19"; 
export const reportActionId = "20";
export const standardPremiumActionId = "21";
export const deliveryStatusActionId = "22";
export const voucherActionId = "23";
export const bankAccountActionId = "24";
export const paymentModeActionId = "25";
export const receiptAccountTypeActionId = "26";
export const clientNameActionId = "27";
export const specialPermissionActionId = "28";
export const accountTypeActionId = "29";
export const cancellationReasonActionId = "30";
export const hsncodeActionId = "31";
export const orderRejectionActionId = "32";
export const vendorActionId = "33";
export const organizersActionId = "34";
export const orderStatusActionId = "35";
export const externalServicesActionId = "36";
export const MasterTimeSlotActionId = "37";
export const MasterConsumableActionId = "38";
export const MastersecurityChecklistId = "39";
export const appVersion = "1.0.0";
export const buildNumber = "20220511";
export const NA = "NA";

// for clear search fields
export const clearSessionStorage = (pageName) => {
  if (pageName === "registrationDesk") {
  }
};

export const sort = (list, tableValue, isSort) => {
  isSort = !isSort;
  if (!isSort) {
    // sorting
    var sort = list.sort((a, b) => {
      const nameA = tableValue.toUpperCase(); // ignore upper and lowercase
      const nameB = tableValue.toUpperCase(); // ignore upper and lowercase
      if (nameA < nameB) {
        return -1;
      }
      if (nameA > nameB) {
        return 1;
      }
      return 0;
    });
    // this.setState({list : sort})
    var data = [sort, !sort];
    return data;
  } else {
    // reverse
    var sort = list.sort((a, b) => {
      const nameA = tableValue.toUpperCase(); // ignore upper and lowercase
      const nameB = tableValue.toUpperCase(); // ignore upper and lowercase
      if (nameA < nameB) {
        return 1;
      }
      if (nameA > nameB) {
        return -1;
      }
      return 0;
    });
    // this.setState({list : sort})
    var data = [sort, !sort];
    return data;
  }
  // this.setState({isToDateSort : !isToDateSort})
};

export const toastError = (msg) => {
  toast.error(msg, {
    position: "top-center",
    theme: "colored",
    autoClose: 3000,
    hideProgressBar: true,
  });
};

export const toastSuccess = (msg) => {
  toast.success(msg, {
    position: "top-center",
    theme: "colored",
    autoClose: 3000,
    hideProgressBar: true,
  });
};

export function timeout(delay) {
  return new Promise((res) => setTimeout(res, delay));
}
